var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#33A6FF",
  fillRule: "evenodd",
  d: "M.786 12C.786 5.807 5.806.786 12 .786S23.214 5.806 23.214 12 18.194 23.214 12 23.214C5.807 23.214.786 18.194.786 12",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8.643 16.714a1 1 0 0 1 1-1h4.714a1 1 0 0 1 0 2H9.643a1 1 0 0 1-1-1",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.429 11.214a1 1 0 0 1 1-1H12a1 1 0 0 1 1 1V16h-2v-3.786h-.572a1 1 0 0 1-1-1M10.607 7.286a1.393 1.393 0 1 1 2.786 0 1.393 1.393 0 0 1-2.786 0"
})));
export default SvgCircle;